import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_LIST } from '../constants';
import { apiProvider } from '../api';
import { listMutations } from './types';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_LIST,
	dropdownList: {
		SkladOzn: [],
		VyrobekndOzn: [],
		ZakaznikSk: [],
		SkladpneuOzn: [],
		DphSzbOzn: [],
		PneuPzn: [],
		VyrobekPneuId: [],
		PstavPzn: [],
		PneuSirkaId: [],
		PneuVyskaId: [],
		PneuRozmerId: [],
	},
	filter: {
		ZaznamId: null as number | null,
		SkladpneuOzn: null as number | null,
		SkladmistopIdOd: null as number | null,
		SkladmistopIdOdPopis: null as string | null,
		SkladmistopIdDo: null as number | null,
		SkladmistopIdDoPopis: null as string | null,
		Text: null as string | null,
		DokladPfx: null as string | null,
		DokladNr: null as string | null,
		ZakaznikId: null as number | null,
		ZakaznikText: null as string | null,
		VstupZakaznikId: null as number | null,
		VstupZakaznikText: null as string | null,
		VozidloId: null as number | null,
		PracovnikId: null as number | null,
		PracovnikText: null as string | null,
		PracovnikOsobniCis: null as string | null,
		VstupPracText: null as string | null,
		VstupPracOsobniCis: null as string | null,
		Poznamka: null as string | null,
		PcOd: null as number | null,
		PcDo: null as number | null,
		DphSzbOzn: null as number | null,
		VstupPracId: null as number | null,
		VstupDatOd: null as string | null,
		VstupDatDo: null as string | null,
		ZakaznikIdText: null as string | null,
		VozidloText: null as string | null,
		PneuPzn: null as number | null,
		VyrobekPneuId: null as number | null,
		PstavPzn: null as number | null,
		PneuText: null as string | null,
		PneusirkaId: null as number | null,
		PneuvyskaId: null as number | null,
		PneuRozmerId: null as number | null,
		DezenHloubkaOd: null as number | null,
		DezenHloubkaDo: null as number | null,
	},
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[listMutations.ZAKAZNIK_SELECT_MAPPER](state, { data }) {
			state.filter.ZakaznikId = data.value;
			state.filter.ZakaznikText = data.text;
		},
		[listMutations.VSTUP_ZAKAZNIK_SELECT_MAPPER](state, { data }) {
			state.filter.VstupZakaznikId = data.value;
			state.filter.VstupZakaznikText = data.text;
		},
		[listMutations.VOZIDLO_SELECT_MAPPER](state, { data }) {
			state.filter.VozidloId = data.value;
			state.filter.VozidloText = data.text;
		},
		[listMutations.SKLAD_MISTO_OD_SELECT_MAPPER](state, { data }) {
			state.filter.SkladmistopIdOd = data.value;
			state.filter.SkladmistopIdOdPopis = data.text;
		},
		[listMutations.SKLAD_MISTO_DO_SELECT_MAPPER](state, { data }) {
			state.filter.SkladmistopIdDo = data.value;
			state.filter.SkladmistopIdDoPopis = data.text;
		},
		[listMutations.VSTUP_PRACOVNIK_SELECT_MAPPER](state, { data }) {
			state.filter.VstupPracId = data.value;
			state.filter.VstupPracText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.filter.VstupPracOsobniCis = data.osobniCis;
		},
		[listMutations.PRACOVNIK_SELECT_MAPPER](state, { data }) {
			state.filter.PracovnikId = data.value;
			state.filter.PracovnikText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.filter.PracovnikOsobniCis = data.osobniCis;
		},
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
		isFilterVisible: true,
	},
});
